import styled, { css } from 'styled-components';
import { margin, MarginProps, padding, PaddingProps } from 'styled-system';

export const SubscriptionComponentsWrapper = styled.div<
  MarginProps & PaddingProps
>`
  ${margin};
  ${padding};
  ${({ theme }) =>
    theme &&
    css`
      border-top: 1px solid ${theme.colors.gray.light};
    `};
`;
